import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { config } from '../config';
import { tap, catchError } from 'rxjs/operators';
import { LicenseData } from '../model/license-data';
import { NbDialogService, NbToastrService } from '@nebular/theme';

import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { Wait } from '../util/timeout';
import { Configuration } from '../model/configuration';
import { stringify } from '@angular/compiler/src/util';
import { Cacheable } from 'ngx-cacheable';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor(private http: HttpClient, private toastrService: NbToastrService,private router: Router) { }

  getDeviceCommPassword(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Configuration/deviceCommPassword`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  getConfigurationKeys(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Configuration/ConfigurationKeys`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  // @Cacheable({
  //     maxCacheCount: 2000,
  //     maxAge: 300000,
  //   })
  get(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Configuration/`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  // @Cacheable({
  //   maxCacheCount: 2000,
  //   maxAge: 300000,
  // })
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Configuration/${id}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  getByKeyNames(keyNames: string[]): Observable<any> {
    let keyNameParams = keyNames.map(kn => `keyNames=${kn}`).join('&');
    return this.http.get<any>(`${config.apiUrl}/Configuration/ByKeyNames/?${keyNameParams}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  getByKeyName(keyname: string): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Configuration/ByKeyName/?key=${keyname}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          //console.log(error.error);
          throw error;
        }));
  }

  buildingName(): Observable<any> {
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    return this.http.get<any>(`${config.apiUrl}/Configuration/buildingName`, { headers: header })
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          throw error.error;
        }));
  }

  put(id: number, configuration: Configuration): Observable<Configuration> {
    return this.http.put<any>(`${config.apiUrl}/Configuration/${id}`,configuration)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(undefined);
        }));
  }

  showMessage(title: string, success: boolean, message: string = '') {
    const status = success ? 'success' : 'danger';
    this.toastrService.show(message, title, { status: status, icon: '' })
  }

  getDatabaseVersion(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Configuration/versions`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  rebornFailedAuths(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Configuration/rebornFailedAuths`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

}
